var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavFloorplans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h34.551v31.157H.001z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.258 12.24L22.311.294a1.003 1.003 0 00-1.414 0l-4.259 4.259-1.779-1.778a1 1 0 00-1.41-.004L.295 15.802a.998.998 0 00-.003 1.417l9.596 9.596a1 1 0 001.404.01l3.433-3.333 7.372 7.372a.997.997 0 001.414 0l2.236-2.236a.999.999 0 10-1.414-1.414l-1.529 1.529-6.64-6.64 3.255-3.131a1.003 1.003 0 00.014-1.428L17.19 15.3a.999.999 0 10-1.414 1.414l1.523 1.523-3.256 3.13v.003h-.003l-3.434 3.334-8.189-8.19 6.611-6.548 2.223 2.223a.993.993 0 00.707.293 1 1 0 00.707-1.707l-2.217-2.217L14.15 4.89l1.782 1.782 5.377 5.378a.997.997 0 001.414 0 1 1 0 000-1.414l-4.67-4.671 3.552-3.552 10.533 10.534-3.552 3.552-1.5-1.5a.999.999 0 10-1.414 1.414l2.207 2.207 2.525 2.524-1.366 1.367a.999.999 0 101.414 1.414l2.073-2.074a1 1 0 000-1.414L30 17.914l4.26-4.26a.999.999 0 000-1.413"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavFloorplans);
export default __webpack_public_path__ + "static/media/nav-floorplans.7a8734edeaa59bc6803e00f4e4a4f53e.svg";
export { ForwardRef as ReactComponent };